import { createFileRoute } from "@tanstack/react-router";
import * as v from "valibot";
import { SubscriptionStatusPage } from "@/pages/subscription-status";

const SubscriptionRoute = () => {
  const { addons } = Route.useSearch();

  return <SubscriptionStatusPage openAiCreditPacks={addons === "ai"} />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/subscription/",
)({
  validateSearch: v.object({ addons: v.optional(v.picklist(["ai"])) }),
  component: SubscriptionRoute,
});
